module.exports = __webpack_public_path__ + "static/img/plus-white.28549d0c.svg";